import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

export const CloseSvg = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                <path d="M24.9999 1L0.999877 25" stroke="currentColor" strokeWidth="1.5" />
                <path d="M1 1L25 25" stroke="currentColor" strokeWidth="1.5" />
            </svg>
        </SvgIcon>
    );
};
